import {Component, input, output, signal} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {DividerModule} from 'primeng/divider';
import {TooltipModule} from 'primeng/tooltip';
import {TranslocoPipe} from '@jsverse/transloco';
import {BaseDialogComponent} from '../base-dialog/base-dialog.component';

@Component({
  selector: 'app-icon-button-dialog',
  imports: [ButtonModule, DividerModule, TooltipModule, TranslocoPipe, BaseDialogComponent],
  templateUrl: './icon-button-dialog.component.html',
  styleUrl: './icon-button-dialog.component.scss',
})
export class IconButtonDialogComponent {
  readonly icon = input.required<string>();
  readonly header = input.required<string>();
  readonly colorClass = input('');
  readonly tooltip = input('');
  readonly disabled = input(false);
  readonly dialogStyleClass = input('icon-button-large');
  readonly testId = input('icon-button-dialog');
  readonly opened = output<void>();

  protected readonly visible = signal(false);

  protected open(): void {
    this.visible.set(true);
    this.opened.emit();
  }

  protected close(): void {
    this.visible.set(false);
  }
}
